import React,{useEffect,useState} from 'react';
import './Website.css'; // You'll need to create a CSS file for styling
import graduation from './images/graduation.jpg' ;
import f from './images/facebook.png' ;
import x from './images/x.png' ;
import instagram from './images/instagram.png' ;
import MyFooter from './my footer';
import ismail from './images/ismail.jpg'
import ismail2 from './images/ismail2.jpg'
import ViceChancellor from './images/Vice Chancellor of University of Somalia.jpg'
import Deputy_Vice_Chancellor from './images/Deputy Vice-Chancellor for Academic Affairs and Research.png'

import axios from 'axios';
import { API_URL, ENDPOINTS,getData } from '../../constants/api';
import { replace } from 'react-router-dom';
import { Link } from "react-router-dom";
import Header from './header';
import { useNavigate } from 'react-router-dom';



const ElearnigHomePage = () => {
    const navigate=useNavigate()
    const [sectionData,setSecrionDate]=useState([]);
    const [Facults,setFacults]=useState([]);
    const [departments,setDepartment]=useState([]);
    const [exprt_instructors,set_exprt_instructors]=useState([]);
    const [our_student,set_our_student ]=useState([]);
    const [loginpage,setLoginPage]=useState('https://elearn.euniso.so/login/student-login')
    const apiKey =
    '3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943';


const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/ELearning-Section`;

useEffect(() => {
    

const getData = async (url) => {

  try {
    const response = await axios.get(url, {
      headers: 
          { 'x-api-key': apiKey }
      ,
    });
    const data = response.data || [];
    setSecrionDate(data.report);
    console.log('url:', url, 'data response:', data.report);
    console.log("sectionData",sectionData);
    console.log('Vision test' ,sectionData[0]['vision']);
    
    
  } catch (error) {
    console.error('Error fetching ', url, ':', error);
  }
};


const getFacults = async (url) => {
 console.log('facult url',url)
  try {
    const response = await axios.get(url, {
      headers: 
          { 'x-api-key': apiKey }
      ,
    });
    const data = response.data || [];
    setFacults(data.report);
    
    console.log("FacultData",Facults);

    
  } catch (error) {
    console.error('Error fetching ', url, ':', error);
  }
};

const getDepartment=async (url)=>{
 
    const response=await axios.get(url,{
        headers:{'x-api-key':apiKey},
    });
    const data=response.data|| [];
   
    setDepartment(data.report)
     console.log('Depatmnet:',departments);
}

const get_expert_instructors= async(url)=>{
 const response=await axios.get(url,
    {
        headers:{'x-api-key':apiKey}
    }
 )
  const data=response.data||[];
   set_exprt_instructors(data.report);
   console.log('expert instructors',data.report)
}

const get_our_student = async(url)=>{
 const response=await axios.get(url,
    {
        headers:{'x-api-key':apiKey}
    }
 )
  const data=response.data||[];
   set_our_student(data.report);
   console.log('our student',data.report)
}



getData(url);
getFacults(`${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-facults`);
getDepartment(`${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-departments`);
get_expert_instructors(`${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/expert-instructors-lists`);
get_our_student(`${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/our_student`)

console.log('img url:',`{${API_URL}/${sectionData[0]?.welcome_image}}`)
}, []); // <-- empty array means run once on mount

useEffect(()=>{
  console.log('department fron above:',departments)
},[departments])




  return (
    <>
    <div className="website-container">
      {/* ==================== HEADER ==================== */}
       <Header></Header>

 <section className="hero-banner"  >
  
  <img   
  src={ismail}
    
    className="hero-iframe"
    
  ></img>
</section>

      {/* ==================== BODY ==================== */}
      <main className="main-content">
           
        {/* Why E-learning Section */}

       

        <section className="why-e-learning-section">
          <div className="why-card">
            <div className="card-icon">🎓</div>
            <h4>Why E-learning</h4>
            <p>{sectionData[0]?.['introduction']}</p>
          </div>
          <div className="why-card">
            <div className="card-icon">🌐</div>
            <h4>Vision Statement</h4>
            <p>{sectionData[0]?.['vision']}</p> 
          </div>
          <div className="why-card">
            <div className="card-icon">🏠</div>
            <h4>Mission Statement</h4>
            <p>{sectionData[0]?.['mission']}</p>
          </div>
          <div className="why-card">
            <div className="card-icon">📖</div>
            <h4>Our Commitments</h4>
            <p>{sectionData[0]?.['commitment']}</p>
          </div>
        </section>

        {/* Welcome to University of Somalia Section */}
        <section className="welcome-section">
  <div className="welcome-image">
    <img
      src={`${API_URL}/${sectionData[0]?.welcome_image?.replace("public/", "")}`}


      alt="University of Somalia graduation ceremony"
    />
  </div>
  <div className="welcome-text-container">
    <div className="about-e-learning-header">ABOUT E-LEARNING</div>
    <h2>Welcome to University of Somalia</h2>
    <p>
        {sectionData[0]?.['welcome_text']}
    </p>
    <p className="signature"> {sectionData[0]?.['short_text']} </p>
    <p className="signature">{sectionData[0]?.['author']}</p>
  </div>
</section>


        {/* University of Somalia E-Learning Faculties Section */}
        <section className="faculties-section">
          <div className="section-header">
            
            <h3>University of Somalia E-Learning Faculties</h3>
            <div className="header-line"></div>
          </div>
          <div className="faculties-list">
  {Facults.map((faculty, index) => (
    <div className="faculty-card" key={index}>
      <img src={`${API_URL}/${faculty.image?.replace('public/','')}`} alt={faculty.name} />
      <div className="faculty-info">
        <h4>{faculty.name}</h4>
        <p>{faculty.facult_count} Programs</p>
      </div>
    </div>
  ))}
</div>

        </section>

        {/* Popular Programs Section */}
        <section className="popular-programs-section">
          <div className="section-header">
            <div className="header-line"></div>
            <h3>Popular Programs</h3>
            <div className="header-line"></div>
          </div>
          <div className="programs-list">

          {
        
            departments.map((department,index)=>(
              
                <div className="program-card" key={index}>
              <div className="program-image">
              <img 
                    src={`${API_URL}/${department.image.replace('public/', '')}`} 
                alt={department.name} 
/>

        
                <div className="program-actions">
                  <button className="action-link"   onClick={() => navigate(`/department/${department.id}`)}>Read More</button>
                  

                    <a className="action-link" href={`portal/New_Online_Student?department_id=${department.id}`}>Apply Now</a>
                  
                </div>
              </div>
              <h4>{department.name}</h4>
              <div className="program-details">
                <span><span className="icon">📝</span> {department.courses} courses</span>
                <span><span className="icon">🕒</span> {department.duration}</span>
              </div>
            </div>
            ))
            
          }
            
          </div>
        </section>

       {/* Experience Statements Section */}
<section className="experience-section">
  <h2>Welcoming Messages from Our E-Learning Leaders</h2>
  

  <div className="experience-list">
    {[
      
      {
        img:  `${ViceChancellor }`,
        name: "Dr. Hassan Mohamed Sayid",
        statement: `It is with great pride and enthusiasm that I welcome you to a new academic year at University of somalia (UNISO) a place where academic excellence, quality teaching, and community engagement come together to shape the leaders of tomorrow.  At the heart of our mission is a steadfast commitment to rigorous scholarship and intellectual growth. Our distinguished faculty are dedicated mentors who inspire curiosity, critical thinking, and innovation in every classroom and research lab. We take pride in fostering an environment where students are challenged to reach their highest potential while contributing meaningfully to their fields of study.  Equally important is our role as a catalyst for positive change in our community. Through service-learning, partnerships with local organizations, and outreach initiatives, we empower our students to apply their knowledge for the greater good. Together, we strive to be not just a leading academic institution but also a force for social impact.  To our students: Your journey here will be transformative, filled with opportunities to learn, lead, and serve. To our faculty and staff: Thank you for your unwavering dedication to nurturing minds and strengthening our university’s legacy. And to our alumni and supporters: Your belief in our vision fuels our progress.  As we embark on this journey, let us continue pursuing excellence in all we do inside and beyond the classroom. The future is bright, and I am honored to walk this path with you.  With warm regards, 
`      , title:"Vice Chancellor of University of Somalia"
      },
      {
        img:  `${Deputy_Vice_Chancellor}`,
        name: "Dr. Mohamed Sh. Isak Hassan",
        statement: `Assalamu Alaykum, It is with tremendous excitement that I welcome you to the University of Somalia's (UNISO)’s E-Learning Program! We sincerely thank you for choosing UNISO. Understanding the need for flexible, accessible, and high-quality learning, we developed this E-Learning Program to allow you to pursue your education beyond the traditional classroom. By leveraging cutting-edge technology, we are dedicated to fostering a learning environment built on engagement, collaboration, and innovation. Our commitment is simple: to deliver online courses that uphold the highest standards of academic quality while ensuring technology reliability, data privacy, and accessibility. Furthermore, UNISO is dedicated to investing in faculty development to ensure the best possible digital instruction. UNISO stands as one of the leading and most student-centered universities in Somalia. We offer a wide range of high-quality programs, all taught by experienced professionals who are ready to support your success. At UNISO, you are always valued, respected, and well-served.
`,      title:"Deputy Vice-Chancellor for Academic Affairs and Research"
      },
      {
        img: `${ismail2}`,
        name: `Eng. Ismail Hussein Ali `,
        statement: `It is my great privilege to welcome you to the University of Somalia's (UNISO) E-Learning Program. Thank you for choosing this exciting and flexible path. Recognizing the evolving demands of the modern world, this program offers you the opportunity to pursue high-quality education from anywhere. Our commitment to you is unwavering: we promise academic excellence, innovative technology, and unparalleled student support. We are excited to see the great things you will achieve through this journey. Welcome aboard!
`,     title:"Director, E-Learning Program of University of Somalia -UNISO"
      },
    ].map((exp, i) => (
      <div key={i} className="experience-card">
        <div className="experience-image">
          <img src={exp.img} alt={exp.name} />
        </div>
        <div className="experience-text">
         
          <p>{exp.statement}</p>
           <h3>{exp.name}</h3>
          <h6>{exp.title}</h6>
        </div>
      </div>
    ))}
  </div>
</section>



        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="section-header">
            <div className="header-line"></div>
            <h3>Our Students Say!</h3>
            <div className="header-line"></div>
          </div>
          <div className="testimonials-list">
           {
            our_student.map((std,index)=>(
            <div className="testimonial-card" key={index}>
              <div className="student-profile">
                <div className="profile-image">👤</div>
                <p>{std.name}</p>
              </div>
              <p className="student-quote">
               {std.student_statement}
              </p>
            </div>
            
            ))
           }
            
          </div>
        </section>
      

      </main>

      {/* ==================== FOOTER ==================== */}
      <MyFooter></MyFooter>
    
    </div>
    
    
    </>
  );
};

export default ElearnigHomePage;